<div class="feature-card-wrap">
  <div class="feature-card">
    <p class="credit-cost-notice" *ngIf="scanCreditCost != null">
      Each video scan costs <strong>{{ scanCreditCost }}</strong>
      {{ scanCreditCost === 1 ? 'credit' : 'credits' }}.
      If the operation fails, credits will be refunded.
    </p>
    <div class="uploader-container">
  <input
    #fileInput
    style="display: none"
    type="file"
    accept="video/*,.mp4,.avi,.mov,.webm"
    (change)="onFileSelected($event)"
  />

  <div class="uploader-box" *ngIf="!uploadedVideo">
    <div
      class="drop-zone"
      [class.drag-over]="isDragOver"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      (click)="triggerFileInput()"
    >
      <div class="drop-zone-content">
        <i class="bi bi-camera-video upload-icon"></i>
        <p class="drop-text">Drop video here to scan for faces</p>
        <p class="upload-hint">or click to browse files</p>
      </div>
    </div>

    <button class="upload-button" (click)="triggerFileInput()">
      <i class="bi bi-plus-circle"></i>
      <span>Upload Video</span>
    </button>
  </div>

  <app-frame-generator
    *ngIf="uploadedVideo"
    [videoData]="uploadedVideo"
    (changeVideo)="onChangeVideo()"
    (showResult)="onShowResult()"
  >
  </app-frame-generator>

  <app-scanned-results *ngIf="uploadedVideo && showResult">
  </app-scanned-results>
    </div>
  </div>
</div>

<!-- Server Video Scanner History (reopens scanned-results UI) -->
<section class="feature-history-section" *ngIf="!uploadedVideo">
  <div class="feature-history-header">
    <h3 class="feature-history-title">Scan History</h3>
    <p class="feature-history-subtitle">
      Saved video scans from the server. Click a row to reopen the same scanned-results view used after a live scan.
    </p>
  </div>

  <div class="feature-history-loading" *ngIf="loadingScannerHistory">
    <div class="spinner-border" role="status"></div>
    <p>Fetching scan history…</p>
  </div>

  <div class="feature-history-table-wrap" *ngIf="!loadingScannerHistory">
    <table class="feature-history-table">
      <thead>
        <tr>
          <th style="width: 10%">Video</th>
          <th style="width: 28%">Name</th>
          <th style="width: 14%">Status</th>
          <th style="width: 12%">Frames</th>
          <th style="width: 12%">Faces</th>
          <th style="width: 12%">Date</th>
          <th style="width: 12%">Time</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!scannerHistoryRows?.length">
          <td colspan="7" class="feature-history-empty">
            No scans yet. Upload a video to see history here.
          </td>
        </tr>
        <tr
          class="table-row"
          *ngFor="let row of scannerHistoryRows"
          (click)="openScannerHistoryResult(row)">
          <td>
            <span class="feature-history-thumb-icon" aria-hidden="true">
              <i class="fas fa-video"></i>
            </span>
          </td>
          <td [title]="row.video_name || 'Untitled video'">
            {{ row.video_name || 'Untitled video' }}
          </td>
          <td>
            <span
              class="feature-history-status"
              [class.status-done]="isHistoryDone(row)"
              [class.status-pending]="!isHistoryDone(row)">
              {{ formatStatus(row.status) }}
            </span>
          </td>
          <td class="feature-history-muted">{{ row.frames_scanned ?? 0 }}</td>
          <td class="feature-history-muted">{{ row.faces_found ?? 0 }}</td>
          <td class="feature-history-muted">{{ row.created_on | date: 'MMM d, y' }}</td>
          <td class="feature-history-muted">{{ row.created_on | date: 'HH:mm:ss' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="feature-history-pagination" *ngIf="scannerHistoryCount > 0">
    <div class="feature-history-pagination-info">
      Showing {{ scannerHistoryPagedStartAndEnd.start }}–{{ scannerHistoryPagedStartAndEnd.end }}
      of {{ scannerHistoryCount }}
    </div>
    <app-paginator
      [totalItems]="scannerHistoryCount"
      [itemsPerPage]="scannerHistoryPerPage"
      [currentPage]="scannerHistoryCurrentPage"
      (pageChange)="onScannerHistoryPageChange($event)">
    </app-paginator>
  </div>
</section>
